import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { DefaultContainedButton } from "@assets/buttons";

const ADImgDialog = ({ open, onClose, filterAD }) => {
  const { img } = filterAD.target;
  const { img_banners } = filterAD;
  const imgData = img_banners.filter((data) => data.ad_id === img);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"lg"}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography
          textAlign="center"
          variant="h2"
          component="div"
          fontWeight={500}
          sx={{ mb: 3, pt: 7.5 }}
        >
          미리보기
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ pl: 10, pr: 10, pb: 0, pt: 0, mb: 1 }}
        >
          {imgData.length !== 0 && (
            <img
              src={imgData[0].img_url}
              alt={imgData[0].img_name ? imgData[0].img_name : "이미지명 없음"}
              width={"480px"}
              height={"165px"}
            />
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="center" alignItems="center">
          <Grid sx={{ width: 210, pb: 6.5 }}>
            <DefaultContainedButton
              color="primary"
              fullWidth={true}
              height={56}
              borderColor="primary.main"
              fontWeight={500}
              onClick={onClose}
              text={
                <Typography
                  textAlign="center"
                  variant="h3"
                  component="div"
                  fontWeight={500}
                >
                  {"확인"}
                </Typography>
              }
            />
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ADImgDialog;
